/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 */
import * as types from "./types";

const mutations = {
  [types.SET_TAB_CONTAINER_SIZE](state, payload) {
    state.tabContainerSize = payload;
  },
  [types.SET_GROUP_TABS](state, payload) {
    state.groupTabs = payload;
  },
  [types.SET_AVAILABLE_SWATCHES_BY_COMPONENT](state, { component, swatches }) {
    state.swatchesByComponent = {
      ...state.swatchesByComponent,
      [component]: swatches
    };
  },
  [types.SET_TABS_SWATCHES_OBJECT_BY_COMPONENT](state, { component, object }) {
    state.tabsSwatches = {
      ...state.tabsSwatches,
      [component]: object
    };
  },
  [types.SET_AVAILABLE_TABS](state, payload) {
    state.availableTabs = payload;
  },
  [types.SET_GROUPS](state, payload) {
    state.groups = payload;
  },
  [types.SET_SUBGROUPS](state, payload) {
    state.subgroups = payload;
  },
  [types.SET_PALETTES](state, payload) {
    if (!state.palettes.includes(payload)) {
      state.palettes.push(payload);
    }
  },
  [types.REMOVE_PALETTE](state, payload) {
    state.palettes = state.palettes.filter(item => item.palette_id !== payload)
  },
  [types.SET_PALETTES_BY_COMPONENT](state, { component, palettes }) {
    state.palettesByComponent = {
      ...state.palettesByComponent,
      [component]: palettes
    };
  },
  [types.SET_TABS_SELECTED](state, { component, tab }) {
    state.selectedTabs = {
      ...state.selectedTabs,
      [component]: tab
    };
  },
  [types.SET_SWATCHES_SELECTED](state, { component, data }) {
    state.selectedSwatches = {
      ...state.selectedSwatches,
      [component]: {
        ...data,
        default: !!data.default
      }
    };
  },
  [types.SET_HISTORY_SELECTED_TABS](state, payload) {
    state.historySelectedTabs.push(payload);
  },
  [types.SET_SWATCHES_RELATION](state, payload) {
    state.swatchesRelation = {
      ...state.swatchesRelation,
      [payload.swatch_id]: { ...payload }
    };
  },
  [types.SET_EXCLUSIVE_SWATCHES](state, { component, swatches }) {
    state.exclusiveSwatches = {
      ...state.exclusiveSwatches,
      [component]: swatches
    };
  },
  [types.SET_DISABLED_SWATCHES_BY_FEATURE](state, {swatches, feature}) {
    if (swatches) {
      state.disabledSwatchesByFeature[feature] = [...swatches];
    }
  },
  [types.SET_PALETTES_ID](state, payload) {
    state.palettesId = [
      ... state.palettesId,
      ... payload
    ].sort((a, b) => a - b);
  },
  [types.SET_PRODUCT_OPTION_TOGGLE](state, {swatchId, status, componentName }) {
    state.productOptionToggle = {
      ...state.productOptionToggle,
      [componentName || swatchId]: { swatchId, status }
    };
  },
  [types.SET_EXCLUSIVE_COMPONENTS](state, { component, components }) {
    state.exclusiveComponents = {
      ...state.exclusiveComponents,
      [component]: components
    };
  },
  [types.SET_LIST_SWATCHES_BY_COMPONENT](state, { component, swatches }) {
    state.swatchesListByComponent = {
      ...state.swatchesListByComponent,
      [component]: swatches
    };
  },
  [types.SET_SWATCHES_IN_PALETTES](state, payload) {
    state.swatchesInPalettes = state.swatchesInPalettes.concat(payload);
  },
  [types.SET_PALETTE_THEME](state, payload) {
    state.paletteTheme = payload;
  },
  [types.CLEAR_STATE_IN_TRANSFERING_DESIGN](state) {
    state.swatchesByComponent = {};
    state.swatchesListByComponent = {};
  },
  [types.SET_PALETTES_HIDDEN_FEATURES](state, payload) {
    state.paletteHiddenFeatures = {
      ...state.paletteHiddenFeatures,
      ...payload
    }
  },
  [types.REMOVE_SELECTED_SWATCH](state, componentName) {
    delete state.selectedSwatches[componentName];
  },
  [types.SET_SPLASH_TABS](state, payload) {
    state.splashTabs = payload;
  },
  [types.UPDATE_PALETTES_ID](state, payload) {
    state.palettesId = [...payload].sort((a,b) => a - b);
  },
  [types.RESET_RELATION_BY_FEATURE](state) {
    for (let feature in state.disabledSwatchesByFeature) {
      state.disabledSwatchesByFeature[feature] = []
    }
  },
  [types.RESET_PALETTES_BY_COMPONENT](state) {
    state.palettesByComponent = {};
  },
};
export default mutations;
